﻿    export const initSettingsPage = () => {
    const showAllDebtorsBtn = document.querySelector('[data-role="show-all-debtors-btn"]');
    
    if (showAllDebtorsBtn) {
        showAllDebtorsBtn.addEventListener('click', () => {
            const url = showAllDebtorsBtn.getAttribute('data-url');
            const title = showAllDebtorsBtn.getAttribute('data-title');

            window.dialog.open({ url, title, size: 'small' });
        });
    }
}